"use strict";
import Api from "../api/api";
export default function toggleHiddenDocument(document, page, refresh) {
  const isHidden = !document.hidden;
  document.hidden = isHidden;
  refresh();
  return Api.DocumentPages.markHidden(page, isHidden).then(refresh);
}
